import { EditorState, ContentState, Modifier, SelectionState } from 'draft-js';
import { Map } from 'immutable';

export function makeList(editorState: EditorState, isOrdered: boolean): EditorState {
  const selectionState = editorState.getSelection();
  let newContentState = Modifier.setBlockType(
    editorState.getCurrentContent(),
    selectionState,
    isOrdered ? 'ordered-list-item' : 'unordered-list-item',
  );

  newContentState = Modifier.removeRange(
    newContentState,
    selectionState.merge({
      anchorOffset: 0,
    }) as SelectionState,
    'forward',
  );

  return EditorState.push(editorState, newContentState, 'change-block-type');
}
